import React from 'react';
import './App.css';
import { Routes, Route } from "react-router";
import { Index } from './pages/Index';
import { LiquidityList } from './pages/LiquidityList';
import { UniswapV2 } from './pages/UniswapV2';
import { UniswapV3 } from './pages/UniswapV3';
import { UniswapV4 } from './pages/UniswapV4';
import { CurveStable } from './pages/CurveStable';


function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/list" element={<LiquidityList />} />
      <Route path="/uniswap_v2/:chain/:pool_id" element={<UniswapV2 />} />
      <Route path="/uniswap_v3/:chain/:pool_id" element={<UniswapV3 />} />
      <Route path="/uniswap_v4/:chain/:pool_id" element={<UniswapV4 />} />
      <Route path="/curve_stable/:chain/:pool_id" element={<CurveStable />} />
    </Routes>
  );
}

export default App;
